//find the enabled route to navigate to
export const getEnabledRoute = (premiumFeatures) =>{

  if(!premiumFeatures) return { path: "/premiumFeatures", isEnabled: true };

  const defaultEnabledRoute =  [
    { path: "/dashboard", isEnabled: premiumFeatures.featureFamilyEngagement === true },
    { path: "/residents", isEnabled: premiumFeatures.featureNonMCareCustomers === true || premiumFeatures.featureMCareContactsProfiles === true || premiumFeatures.featureFamilyEngagement === true
  || premiumFeatures.featureNonMCareCustomers === true
  || premiumFeatures.featureMCareContactsProfiles === true },
    { path: "/family-members", isEnabled: premiumFeatures.featureFamilyEngagement === true },
    { path: "/calendar", isEnabled: premiumFeatures.isStaffHubCalendar === true },
    { path: "/gallery", isEnabled: premiumFeatures.isStaffHubContentManagerGallery === true },
    { path: "/digital-signage", isEnabled: premiumFeatures.featureDigitalSignage === true },
    { path: "/contentLibrary", isEnabled: premiumFeatures.isStaffHubContentManagerMediaLibrary === true },
    { path: "/lifestyle-programs", isEnabled: premiumFeatures.featureLifestyle === true },
    { path: "/concierge-list", isEnabled: premiumFeatures.featureConcierge === true },
    { path: "/maintenanceDashboard", isEnabled: premiumFeatures.featureMaintenance === true },
    { path: "/reports", isEnabled: true },
    { path: "/surveys", isEnabled: premiumFeatures.isStaffHubSurveys === true },
    { path: "/guestbook", isEnabled: true },
    { path: "/messaging", isEnabled: premiumFeatures.isStaffHubMessenger === true },
    { path: "/devices", isEnabled: true },
    { path: "/premiumFeatures", isEnabled: true }, // default route if no premium features are enabled (currently not used)

  ].find((route) => route.isEnabled);

  return defaultEnabledRoute
}

export const getNextRouteData = (enabledRoutePath: string, to: any) =>{
  if(enabledRoutePath === to.path) {
    return { path: enabledRoutePath, query: { redirect: to.fullPath }}
  }
  else {
    return { path: enabledRoutePath}
  }
}